module.exports = __webpack_public_path__ + "static/media/Terms_Conditions.88faa005.png";